import DataTable from './DataTable'
import PrintableDataTable from './PrintableDataTable'
import { Column } from 'primereact/column'

export default DataTable;
export { Column, PrintableDataTable };